'use strict';

/**
 * 获取各分校对应的默认手机区号
 * @param {*} schoolCode 分校编码
 * @returns 默认手机区号
 */
 const getDefaultPhoneAreaCode = (schoolCode) => {
  const map = new Map([
    [4401, {
      value: '44',
      countryCode: 'uk',
    }],
    [6501, {
      value: '65',
      countryCode: 'sg',
    }],
    [6502, {
      value: '86',
      countryCode: 'cn',
    }],
    [415, {
      value: '1',
      countryCode: 'us',
    }],
    [85201, {
      value: '852',
      countryCode: 'hk',
    }],
    [8601, {
      value: '86',
      countryCode: 'cn',
    }],
    [6101, {
      value: '61',
      countryCode: 'au',
    }],
    [6001, {
      value: '60',
      countryCode: 'my',
    }],
    [103, {
      value: '1',
      countryCode: 'ca',
    }],
    [104, {
      value: '1',
      countryCode: 'tc',
    }],
    [8602, {
      value: '86',
      countryCode: 'cn',
    }],
    [6503, {
      value: '65',
      countryCode: 'sg',
    }],
    [6504, {
      value: '86',
      countryCode: 'cn',
    }],
    [6505, {
      value: '86',
      countryCode: 'cn',
    }],
    [105, {
      value: '1',
      countryCode: 'us',
    }],
    [6506, {
      value: '65',
      countryCode: 'sg',
    }],
    [8101, {
      value: '81',
      countryCode: 'jp',
    }],
    [8201, {
      value: '82',
      countryCode: 'kr',
    }],
    [3301, {
      value: '33',
      countryCode: 'fr',
    }],
  ]);

  return map.get(schoolCode * 1)
};

/**
 * 获取各分校默认国家两字母缩写
 * @param {*} schoolCode 分校编码
 * @returns 国家两字母缩写
 */
const getDefaultCountryShortCode = (schoolCode) => {
  const map = new Map([
    [4401, 'UK'],
    [6501, 'SG'],
    [6502, 'CN'],
    [415, 'US'],
    [85201, 'HK'],
    [8601, 'CN'],
    [6101, 'AU'],
    [6001, 'MY'],
    [103, 'CA'],
    [104, 'TC'],
    [8602, 'AI'],
    [6503, 'SG'],
    [6504, 'SG'],
    [6505, 'SG'],
    [6506, 'SG'],
    [105, 'US'],
    [8101, 'JP'],
    [8201, 'KR'],
    [3301, 'FR'],
  ]);

  return map.get(schoolCode * 1)
};

var baseCommon = {
  getDefaultPhoneAreaCode,
  getDefaultCountryShortCode,
};

/**
 * 分校通用配置
 */

// 国家域名语言环境映射关系
const domainsLocaleMap = {
  // 产研测试分校
  'mars.thethinkacademy.com': 'cn',
  // 英国域名
  'thinkacademy.uk': 'uk',
  'uk.thethinkacademy.com': 'uk',
  // 新加坡域名
  'thinkacademy.sg': 'sg',
  'sg.thethinkacademy.com': 'sg',
  // 美国域名
  'www.thethinkacademy.com': 'us',
  'touch.thethinkacademy.com': 'us',
  'us.thethinkacademy.com': 'us',
  'quiz.thethinkacademy.com': 'us',
  // 香港域名
  'hk.thethinkacademy.com': 'hk',
  // 数学竞赛分校
  'globalmathclub.com': 'tmc',
  // 澳大利亚
  'au.thethinkacademy.com': 'au',
  // 马来西亚
  'thinkacademymy.com': 'my',
  'my.thethinkacademy.com': 'my',
  // 加拿大
  'thinkacademy.ca': 'ca',
  'ca.thethinkacademy.com': 'ca',
  // Think Chinese
  'chinese.thethinkacademy.com': 'tc',
  // AI 大学
  'ai.tal.com': 'ai',
  'touch-ai.tal.com': 'ai',
  // 自适应
  'think-matrix.com': 'tm',
  'touch.think-matrix.com': 'tm',
  // 智慧教育平台
  'ai4math.org': 'am',
  'touch.ai4math.org': 'am',
  'ai4edu.org': 'ae',
  'touch.ai4edu.org': 'ae',
  'sg.bettermeedu.com': 'bmsg',
  'touch-sg.bettermeedu.com': 'bmsg',
  'www.bettermeedu.com': 'bmus',
  'us.bettermeedu.com': 'bmus',
  'touch.bettermeedu.com': 'bmus',
  // 日本
  'jp.thethinkacademy.com': 'jp',
  // 韩国
  'kr.thethinkacademy.com': 'kr',
  // 法国
  'fr.thethinkacademy.com': 'fr',
};

// 国家编码映射关系
const countryCodeMap = {
  // 英国
  uk: 'uk',
  // 新加坡
  sg: 'sg',
  // 美国
  us: 'us',
  // 产研测试分校
  cn: 'cn',
  // 香港
  hk: 'hk',
  // 数学竞赛分校
  tmc: 'tmc',
  // 澳大利亚
  au: 'au',
  // 马来西亚
  my: 'my',
  // 加拿大
  ca: 'ca',
  // Think Chinese
  tc: 'tc',
  // AI 大学
  ai: 'ai',
  // 自适应分校
  tm: 'tm',
  // 智慧教育
  am: 'am',
  ae: 'ae',
  bmsg: 'bmsg',
  // 美国
  bmus: 'bmus',
  // 日本
  jp: 'jp',
  // 韩国
  kr: 'kr',
  // 法国
  fr: 'fr',
};

// 分校码映射关系
const schoolCodeMap = {
  // 产研测试分校
  cn: '8601',
  // 英国
  uk: '4401',
  // 新加坡
  sg: '6501',
  // 美国
  us: '415',
  // 香港
  hk: '85201',
  // 数学竞赛分校
  tmc: '6502',
  // 澳大利亚
  au: '6101',
  // 马来西亚
  my: '6001',
  // 加拿大
  ca: '103',
  // Think Chinese
  tc: '104',
  // AI 大学
  ai: '8602',
  // 自适应分校
  tm: '6503',
  // 智慧教育
  am: '6504',
  ae: '6505',
  bmsg: '6506',
  // 美国
  bmus: '105',
  // 日本
  jp: '8101',
  // 韩国
  kr: '8201',
  // 法国
  fr: '3301',
};

// 预设语言环境
const fallbackLocale = 'sg';

// 有效的语言环境编码
const validLocales = ['uk', 'sg', 'us', 'hk', 'tmc', 'au', 'my', 'ca', 'tc', 'ai', 'tm', 'jp', 'kr', 'fr'];

var baseConfig = {
  domainsLocaleMap,
  countryCodeMap,
  schoolCodeMap,
  fallbackLocale,
  validLocales,
};

var index = {
  baseCommon,
  baseConfig,
};

module.exports = index;
